<template>
    <select v-model="displayValue" class="form-control" id="id_rastreador" >
        <option v-for="sn in simnao" :value="sn.value">{{sn.name}}</option>
    </select>
</template>

<script>
    import {Utils} from "../../class/utils";
    export default {
        name: "ComboTrueFalse",
        props: {
            "value": {
                "default": null
            }
        },
        data(){
            return {
                simnao: Utils.simnao(),
            };
        },
        computed: {
            displayValue: {
                get() {
                    return !!this.value;
                },
                set(modifiedValue) {
                    this.$emit("input", modifiedValue);
                }
            }
        }
    }
</script>
